import React from 'react';
import { motion } from 'framer-motion';

const variants = {
  primary: 'bg-zinc-900 text-white hover:bg-zinc-800 shadow-md',
  secondary: 'bg-white text-zinc-900 border border-zinc-200 hover:bg-zinc-50 shadow-sm',
  ghost: 'bg-transparent text-zinc-600 hover:text-zinc-900 hover:bg-zinc-100',
  brand: 'bg-[#D4B483] text-[#1A2E22] hover:bg-[#c4a473] shadow-md',
};

const sizes = {
  sm: 'px-4 py-2 text-xs',
  md: 'px-6 py-2.5 text-sm',
  lg: 'px-8 py-3.5 text-base',
};

export const Button = React.forwardRef(({ 
  children, 
  variant = 'primary', 
  size = 'md', 
  className = '', 
  fullWidth = false,
  ...props 
}, ref) => {
  const baseStyles = 'inline-flex items-center justify-center font-bold tracking-wide rounded-xl transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-zinc-900 focus:ring-offset-2 active:scale-[0.98]';
  
  return (
    <motion.button
      ref={ref}
      whileHover={{ y: -2 }}
      className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${fullWidth ? 'w-full' : ''} ${className}`}
      {...props}
    >
      {children}
    </motion.button>
  );
});

Button.displayName = 'Button';